import type { ExistingVideos } from "./loadPanel.types";

export const existingVideos: ExistingVideos = {
    pl: {
        pl: {
            orange_pl: {
                iphone: {
                    backsidebottomcorner: [{ type: "video" }],
                    backsidetopcorner: [{ type: "video" }],
                    front: [{ type: "video" }],
                    frontbattery: [{ type: "video" }],
                    frontimei: [{ type: "video" }],
                },
                smartphone: {
                    back: [{ type: "video" }],
                    backsidebottomcorner: [{ type: "video" }], // *** //
                    backsidetopcorner: [{ type: "video" }], // *** //
                    front: [{ type: "video" }], // *** //
                    frontimei: [{ type: "video" }],
                    frontmodel: [{ type: "video" }],
                },
            },
        },
        en: {
            "orange.pl": {
                iphone: {
                    backsidebottomcorner: [{ type: "video" }],
                    backsidetopcorner: [{ type: "video" }],
                    front: [{ type: "video" }],
                    frontbattery: [{ type: "video" }],
                    frontimei: [{ type: "video" }],
                },
                smartphone: {
                    back: [{ type: "video" }],
                    backsidebottomcorner: [{ type: "video" }], // *** //
                    backsidetopcorner: [{ type: "video" }], // *** //
                    front: [{ type: "video" }], // *** //
                    frontimei: [{ type: "video" }],
                    frontmodel: [{ type: "video" }],
                },
            },
        },
    },
};
